var map = {
	"./1- CASS Testi - Salt Spray and Alternating Climate Test.jpg": 5701,
	"./1-S2.jpg": 6186,
	"./2- Cok Eksenli Yorulma Testi (Multi-Axial Fatigue Test (ZWARP)).jpg": 4673,
	"./2-S3.jpg": 3268,
	"./3-S4.jpg": 4707,
	"./4- 3D Olcum Cihazi (3D Measurement Device).jpg": 5851,
	"./4-AE.jpg": 4206,
	"./5-K1.jpg": 6299,
	"./6-tinted_clear_coat_applications.jpg": 1135,
	"./BASIN - Cevher Markalı Jantlar Yol Çıkıyor.jpg": 8850,
	"./Cevher ISO 500 ve EBSO 100 Listelerinde.jpg": 621,
	"./Solaris5.jpg": 2889,
	"./a210680-overfull_6087f6465ce1d.jpg": 7059,
	"./basinda-biz-cevher-grubundan-surdurulebilir-buyume_5f215f952e750.jpg": 3185,
	"./cbu_egitim.jpg": 4708,
	"./cevher_slider_banner-1.df2341f8-1.webp": 1522,
	"./cevher_slider_banner-1.df2341f8.jpg": 3855,
	"./cevher_slider_banner-1.df2341f8.webp": 9560,
	"./cevher_slider_banner-2-2.cbc16912.webp": 7862,
	"./cevher_slider_banner-2.cbc16912-1.webp": 902,
	"./cevher_slider_banner-2.cbc16912-mobile.webp": 3164,
	"./cevher_slider_banner-2.cbc16912.jpg": 1475,
	"./cevher_slider_banner-2.cbc16912.webp": 1177,
	"./climate_en.pdf": 7247,
	"./climate_tr.pdf": 9088,
	"./customer-map.33908c8b.png": 2541,
	"./deu_ders.jpg": 6023,
	"./huseyin_ozyavuz_portre (1).webp": 583,
	"./huseyin_ozyavuz_portre.webp": 4389,
	"./industrial-design-1.8166b81f.png": 6601,
	"./industrial-design-2.aa7c32ef.png": 6605,
	"./intern-1.ac2e629d.jpg": 2949,
	"./intern-2.a83f8c9f.jpg": 1201,
	"./intern-3.809ad2ad.jpg": 4179,
	"./kizilay.jpg": 2431,
	"./koln-1.JPG": 7699,
	"./map.57aff948.png": 6415,
	"./our-products.51d44431.webp": 6285,
	"./powertrail.94db9a95.jpg": 310,
	"./product-1.c972327b.jpg": 8923,
	"./product-2.e1699e55.jpg": 4194,
	"./product-3.a7530c0e.jpg": 6397,
	"./production-process.e4aa169a.jpg": 9231,
	"./production.9fb36f20.webp": 3488,
	"./production/foundry/1- Dokumhane (Foundry).jpg": 9426,
	"./production/foundry/2- Dokumhane (Foundry).jpg": 9525,
	"./production/foundry/3 - Ergitme (Melting).jpg": 8459,
	"./production/foundry/4 - Ergitme (Melting).jpg": 3334,
	"./production/foundry/5- Ergitme (Melting).jpg": 1951,
	"./production/foundry/6- X-Ray (X-Ray).jpg": 9456,
	"./production/foundry/7 - Isil Islem (Heat Treatment).jpg": 6068,
	"./production/machining/1- Robot Isleme Hucresi (Robot Machining Cell).jpg": 6545,
	"./production/machining/2- Robot Isleme Hucresi (Robot Machining Cell).jpg": 5791,
	"./production/machining/3- Talasli Imalat (Machining).jpg": 3349,
	"./production/machining/4- Tunel Yikama Makinesi (Tunnel Cleaning Machine).jpg": 6346,
	"./production/machining/5- Helyum Sizdirma Testi - Helium Leakage Test.jpg": 759,
	"./production/machining/6- Diamond Cut - Diamond Cut.jpg": 8636,
	"./production/machining/7- On yuzey fircalama -Front surface brushing.gif": 2668,
	"./production/machining/8- Tornalama-Turning Operation.jpg": 5784,
	"./production/paintshop/1- Yukleme Robotu (Loading Robot).jpg": 3451,
	"./production/paintshop/2- On Islem Firini (Pretreatment System).jpg": 2965,
	"./production/paintshop/3- Transfer Robotlari (Transfer Robots).jpg": 2821,
	"./production/paintshop/4- Toz Boya (Powder Coating).jpg": 4935,
	"./production/paintshop/5- Toz Boya (Powder Coating).jpg": 5139,
	"./production/paintshop/6- Yas Boya (Spray Finishing).jpg": 506,
	"./production/paintshop/7- Yas Boya (Spray Finishing).jpg": 2723,
	"./production/paintshop/8- Son Kontrol (Final Inspection).jpg": 6846,
	"./production/quality/1- CASS Testi - Salt Spray and Alternating Climate Test.jpg": 2797,
	"./production/quality/2-OKEK~1.JPG": 7163,
	"./production/quality/3- Radyal Darbe Testi (Radial Impact Test).jpg": 9108,
	"./production/quality/4- 3D Olcum Cihazi (3D Measurement Device).jpg": 1761,
	"./production/quality/5- Dinamik Yorulma Testi (Dynamic Fatigue Test).jpg": 8114,
	"./production/quality/6- Mikroskop (Microskop).jpg": 9163,
	"./production/quality/7- Spektrometre (Spectrometer).jpg": 7961,
	"./production/quality/8- Cekme Testi - Tensile Test.jpg": 3258,
	"./quality-1.b909e05d.png": 3526,
	"./quality-2.4e2bd748.png": 233,
	"./quality-3.bdd88902.png": 1132,
	"./rnd-1.40517464.png": 8559,
	"./rnd-2.0c3f01d7.png": 6363,
	"./rnd-3.0f125296.png": 2529,
	"./rnd-4.f153c923.png": 8408,
	"./solaris.JPG": 6532,
	"./values-and-ethics.931f1232.jpg": 9962
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4848;